/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tim_S2Inputs */

const en_mk_tut_tim_s2 = /** @type {(inputs: Mk_Tut_Tim_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are three roles. **Owner** handles billing and can delete the workspace. **Admin** manages members, divisions and agents. **Member** does the day-to-day work.`)
};

const id_mk_tut_tim_s2 = /** @type {(inputs: Mk_Tut_Tim_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada tiga peran. **Pemilik** mengatur tagihan dan bisa menghapus workspace. **Admin** mengelola anggota, divisi, dan agen. **Anggota** mengerjakan pekerjaan sehari-hari.`)
};

/**
* | output |
* | --- |
* | "There are three roles. **Owner** handles billing and can delete the workspace. **Admin** manages members, divisions and agents. **Member** does the day-to-da..." |
*
* @param {Mk_Tut_Tim_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tim_s2 = /** @type {((inputs?: Mk_Tut_Tim_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tim_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tim_s2(inputs)
	return en_mk_tut_tim_s2(inputs)
});